<!-- eslint-disable no-empty -->
<template>
  <div id="myitem">
    <div id="note">
      <div class="container fluid grid-list-sm">
        <div class="layout justify-start row wrap">
          <div
            class="flex md6 xs12"
            v-for="(item, index) in itemList"
            :key="index"
          >
            <a :href="item.url"
              target="_blank" ><div
                class="
                  little-shadow
                  custom-ripple
                  ma-1
                  post-title-link
                  v-card v-sheet
                  theme--light
                "
              >
                <div class="v-card__text word">
                  <a>{{ item.title }}</a>
                </div>
              </div></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
	data() {
		return {
			itemList: [
				{
					title: "随机数",
					url: "myitem/random/index.html",
				},
				{
					title: "打造前程官网",
					url: "firmWeb/index.html",
				},
			],
			imgList: {},
		};
	},

	methods: {},
};
</script>
<style scoped>
.word {
	font-size: 15px;
	padding: 0px;
	font-weight: normal;
}
a {
	color: black;
	text-decoration: none;
}

.little-shadow {
	box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14),
		0 1px 3px 0 rgba(0, 0, 0, 0.12);
}
.post-title-link {
	padding: 12px 30px;
}
.post-title-link:hover {
	border-left: 5px solid rgba(21, 101, 192, 0.8);
	padding: 12px 25px;
}
.summary {
	overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
	color: gray;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 14px;
}
.date {
	color: gray;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 14px;
	line-height: 16px;
}
.action {
	padding: 0 12px 16px 16px;
}
.main-title {
	padding: 0px;
	margin: 0px;
	font-size: 16px;
	font-weight: bold;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.Bili-title {
	padding-left: 10px;
	text-overflow: unset;
	white-space: unset;
}
.Bili-number {
	color: #af5e53;
}
</style>
